// src/config.js
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'; // Default to local backend if not defined
export default API_URL;